import { prefixObjectValues } from '../utils';

const modal = {
  form: 'form',
  typeSelect: 'type-select',
  numberInput: 'number-input',
  issueDatePicker: 'issue-date',
  expirationDatePicker: 'expiry-date',
  renewalDatePicker: 'renew-date',
  inactiveDatePicker: 'inactive-date',
  statusSelect: 'status-select',
  stateSelect: 'state-select',
  countrySelect: 'country-select',
  // [MCV-1574] `inactiveCheck: 'inactive-toggle'` removed with the manual
  // toggle it selected — the inactive fields are revealed by the licence
  // status now, so there is no toggle for a test to click.
  inactiveExplanation: 'explain-text',
  submitBtn: 'submit-btn',
  closeBtn: 'close-btn',
};

export default prefixObjectValues(modal, 'medical-license-form');
